import { ReactComponent as Icon } from "../assets/icons/chats/share.svg";
import genIcons from "./genIcons";

const Share = { Outline: genIcons(Icon, { htmlColor: "transparent" }) };

export default Share;
